import React from 'react'
import { useContext } from 'react';
import { Grid } from '@mui/material';
import { MyContext } from '../../context/MyContext';
import Typography from '@mui/material/Typography';
import ProgressBar from '../ProgressBar/ProgressBar';
import ProdutosNaoLocalizados from '../../../src/assets/img/produtos_nao_localizados.svg';

function Nemhum_Produto() {
    const { showLoading, setShowLoading } = useContext(MyContext);        

    return (
        <div>
            <Grid
                container
                spacing={3}
                direction="row"
                justify="center"
                alignItems="stretch"
            >
                <Grid item xs={12} minHeight={'450px'} style={{ marginTop: '20px' }}>                    
                    {(showLoading ? <><ProgressBar /></> : <></>)}
                    <img src={ProdutosNaoLocalizados} alt="Nada Localizado" style={{ width: '100px', height: 'auto' }} />
                    <Typography variant="h6">Infelizmente, Nenhum Produto Foi Localizado!</Typography>
                </Grid>
            </Grid>
        </div>
    )
}
export default Nemhum_Produto